"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var foundation_1 = require("../../theme/foundation");

var checkboxes_1 = require("../checkboxes");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.InputField = utils_2.forwardRef(function InputField(props) {
  var placeholder = props.placeholder,
      type = props.type,
      textError = props.textError,
      rows = props.rows,
      helperText = props.helperText,
      disabled = props.disabled,
      trailingIcon = props.trailingIcon,
      isTooltip = props.isTooltip,
      width = props.width,
      isTextarea = props.isTextarea,
      children = props.children,
      data = props.data,
      isDropdown = props.isDropdown,
      maxHeight = props.maxHeight,
      action = props.action,
      onChange = props.onChange,
      onChangeSecond = props.onChangeSecond,
      leftIcon = props.leftIcon,
      value = props.value,
      secondValue = props.secondValue,
      white = props.white,
      onClickTrailingIcon = props.onClickTrailingIcon,
      _onBlur = props.onBlur,
      _onFocus = props.onFocus,
      ref = props.ref,
      onKeyPress = props.onKeyPress,
      rest = __rest(props, ["placeholder", "type", "textError", "rows", "helperText", "disabled", "trailingIcon", "isTooltip", "width", "isTextarea", "children", "data", "isDropdown", "maxHeight", "action", "onChange", "onChangeSecond", "leftIcon", "value", "secondValue", "white", "onClickTrailingIcon", "onBlur", "onFocus", "ref", "onKeyPress"]);

  var _a = React.useState(''),
      inputValue = _a[0],
      setInputValue = _a[1];

  var containerRef = React.useRef(null);

  var _b = React.useState(false),
      hoverStatus = _b[0],
      setHoverStatus = _b[1];

  var _c = React.useState(false),
      dropdownStatus = _c[0],
      setDropdownStatus = _c[1];

  var _d = React.useState(false),
      visibleDropdown = _d[0],
      setVisibleDropdown = _d[1];

  var _e = React.useState([]),
      selectedItems = _e[0],
      setSelectedItems = _e[1];

  var parentContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: ", ";\n\t"], ["\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: ", ";\n\t"])), width || '100%');
  var flexColumn = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t"], ["\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t"])));
  var container = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t--InputField-border-radius: 30px;\n\t\t--InputField-cursor: pointer;\n\t\t--InputField-border: none;\n\t\t--InputField-min-width: 100px;\n\t\t--InputField-min-height: 30px;\n\t\t--InputField-background-color: white;\n\t\tbackground: ", ";\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\t//border: solid 1px $ {textError ? colors.primary.red : fieldset ? colors.primary.green : isHover || value || (selectedItems && selectedItems.length > 0) ? colors.secondary.mediumGrey : colors.shades.strokes};\n\t\t//border-top-color: $ {fieldset && !action && placeholder ? 'transparent' : textError ? colors.primary.red : fieldset ? colors.primary.green : isHover || value || (selectedItems && selectedItems.length > 0) ? colors.secondary.mediumGrey : colors.shades.strokes};\n\t\tborder-radius: 4px;\n\t\ttransition: all 0.1s ease-in-out;\n\t"], ["\n\t\t--InputField-border-radius: 30px;\n\t\t--InputField-cursor: pointer;\n\t\t--InputField-border: none;\n\t\t--InputField-min-width: 100px;\n\t\t--InputField-min-height: 30px;\n\t\t--InputField-background-color: white;\n\t\tbackground: ", ";\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\t//border: solid 1px $ {textError ? colors.primary.red : fieldset ? colors.primary.green : isHover || value || (selectedItems && selectedItems.length > 0) ? colors.secondary.mediumGrey : colors.shades.strokes};\n\t\t//border-top-color: $ {fieldset && !action && placeholder ? 'transparent' : textError ? colors.primary.red : fieldset ? colors.primary.green : isHover || value || (selectedItems && selectedItems.length > 0) ? colors.secondary.mediumGrey : colors.shades.strokes};\n\t\tborder-radius: 4px;\n\t\ttransition: all 0.1s ease-in-out;\n\t"])), white ? foundation_1.colors.white : 'transparent');
  var input = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t.MuiOutlinedInput-root {\n\t\t\tmin-height: 55px !important;\n\t\t}\n\t\t.MuiInputBase-input {\n\t\t\tborder: none !important;\n\t\t\tcolor: ", ";\n\t\t}\n\t\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\t\tcolor: ", "!important;\n\t\t}\n\t\t.MuiInputLabeL-outlined {\n\t\t\tborder: none !important;\n\t\t}\n\t\t.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n\t\t\tborder-color: ", "!important;\n\t\t}\n\t\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\t\tcolor: ", "!important;\n\t\t}\n\t\t.MuiOutlinedInput-notchedOutline {\n\t\t\tborder-color: ", "!important;\n\t\t}\n\t\tcursor: ", ";\n\t"], ["\n\t\t.MuiOutlinedInput-root {\n\t\t\tmin-height: 55px !important;\n\t\t}\n\t\t.MuiInputBase-input {\n\t\t\tborder: none !important;\n\t\t\tcolor: ", ";\n\t\t}\n\t\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\t\tcolor: ", "!important;\n\t\t}\n\t\t.MuiInputLabeL-outlined {\n\t\t\tborder: none !important;\n\t\t}\n\t\t.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n\t\t\tborder-color: ", "!important;\n\t\t}\n\t\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\t\tcolor: ", "!important;\n\t\t}\n\t\t.MuiOutlinedInput-notchedOutline {\n\t\t\tborder-color: ", "!important;\n\t\t}\n\t\tcursor: ", ";\n\t"])), isDropdown && selectedItems && selectedItems.length > 1 ? foundation_1.colors.primary.green : 'inherit', isDropdown && selectedItems && selectedItems.length > 1 ? foundation_1.colors.primary.green : foundation_1.colors.secondary.mediumGrey, hoverStatus ? textError ? foundation_1.colors.primary.red : foundation_1.colors.primary.green : foundation_1.colors.secondary.mediumGrey, hoverStatus ? textError ? foundation_1.colors.primary.red : foundation_1.colors.primary.green : foundation_1.colors.secondary.mediumGrey, hoverStatus ? textError ? foundation_1.colors.primary.red : foundation_1.colors.primary.green : foundation_1.colors.secondary.mediumGrey, disabled ? 'not-allowed' : 'inherit');
  var statusIcon = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\twidth: 50px;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t"], ["\n\t\tdisplay: flex;\n\t\twidth: 50px;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t"])));
  var icon = core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 32px;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t"], ["\n\t\tdisplay: flex;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 32px;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t"])), foundation_1.colors.white, foundation_1.colors.primary.green);
  var iconError = core_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 32px;\n\t\tbackground: rgba(202, 18, 52, 0.1);\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t"], ["\n\t\tdisplay: flex;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 32px;\n\t\tbackground: rgba(202, 18, 52, 0.1);\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t"])), foundation_1.colors.primary.red);
  var message = core_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\tmin-height: 50px;\n\t\tdisplay: flex;\n\t\tfont-size: 12px;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t"], ["\n\t\tmin-height: 50px;\n\t\tdisplay: flex;\n\t\tfont-size: 12px;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t"])), textError ? foundation_1.colors.primary.red : foundation_1.colors.secondary.grey);
  var trailingIconStyle = core_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\twidth: 40px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: ", ";\n\t\tcursor: ", ";\n\t"], ["\n\t\twidth: 40px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: ", ";\n\t\tcursor: ", ";\n\t"])), foundation_1.colors.primary.green, onClickTrailingIcon ? 'pointer' : 'inherit');
  /*
      SelectBox part
   */

  var optionsContainer = core_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 14px;\n\t\tborder-radius: 0 0 8px 8px;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t\tmax-height: ", ";\n\t\toverflow: auto;\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 14px;\n\t\tborder-radius: 0 0 8px 8px;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t\tmax-height: ", ";\n\t\toverflow: auto;\n\t"])), maxHeight || '100%');
  var optionRow = core_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tpadding-top: 0.688rem;\n\t\tpadding-bottom: 0.688rem;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tpadding-left: 1em;\n\t\tcursor: pointer;\n\t\ttransition: all 150ms ease-in-out;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 150ms ease-in-out;\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\tpadding-top: 0.688rem;\n\t\tpadding-bottom: 0.688rem;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tpadding-left: 1em;\n\t\tcursor: pointer;\n\t\ttransition: all 150ms ease-in-out;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 150ms ease-in-out;\n\t\t}\n\t"])), foundation_1.colors.shades.bgLightGrey);
  var optionRowSelected = core_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tpadding-top: 0.688rem;\n\t\tpadding-bottom: 0.688rem;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tpadding-left: 16px;\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\ttransition: all 150ms ease-in-out;\n\t"], ["\n\t\twidth: 100%;\n\t\tpadding-top: 0.688rem;\n\t\tpadding-bottom: 0.688rem;\n\t\tdisplay: flex;\n\t\tfont-size: 14px;\n\t\talign-items: center;\n\t\tpadding-left: 16px;\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\ttransition: all 150ms ease-in-out;\n\t"])), foundation_1.colors.shades.bgLightGrey);
  var leftIconPart = core_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\t\twidth: 42px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tfont-size: 18px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: ", ";\n\t"], ["\n\t\twidth: 42px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tfont-size: 18px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: ", ";\n\t"])), foundation_1.colors.primary.green);

  var updateIndexes = function updateIndexes(value) {
    var currentItems;

    if (selectedItems.find(function (d) {
      return d.value === value;
    })) {
      currentItems = selectedItems.filter(function (d) {
        return d.value !== value;
      });
    } else {
      currentItems = __spreadArrays(selectedItems, [data.find(function (d) {
        return d.value === value;
      })]);
    }

    if (currentItems.length === 0) {
      setInputValue('');
    } else if (currentItems.length === 1) {
      if (data && !!data.length) {
        setInputValue("" + currentItems[0].name);
      }
    } else {
      setInputValue(currentItems.length + " elements selected");
    }

    setSelectedItems(currentItems);
  };

  var onChangeInput = function onChangeInput(event) {
    setInputValue(event.target.value);

    if (onChange) {
      onChange(event);
    }
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: parentContainer,
    ref: containerRef
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: flexColumn
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: container
  }, leftIcon && (0, _core.jsx)(lseds_1.lseds.div, {
    css: leftIconPart
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: leftIcon
  })), (0, _core.jsx)(TextField_1["default"], {
    css: input,
    disabled: disabled,
    multiline: isTextarea,
    rows: rows,
    fullWidth: !!width,
    style: {
      width: width || '100%'
    },
    label: placeholder,
    variant: "outlined",
    type: type || 'text',
    onMouseEnter: function onMouseEnter() {
      return setHoverStatus(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverStatus(false);
    },
    onFocus: function onFocus() {
      if (_onFocus) {
        _onFocus();
      }

      setDropdownStatus(true);
    },
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur();
      }

      if (!visibleDropdown) {
        setDropdownStatus(false);
      }
    },
    value: isDropdown ? inputValue : value,
    onChange: onChangeInput,
    ref: ref,
    onKeyPress: onKeyPress
  }), trailingIcon && (0, _core.jsx)(lseds_1.lseds.div, {
    css: trailingIconStyle,
    onClick: onClickTrailingIcon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: trailingIcon
  })), action), (textError || isTooltip) && (0, _core.jsx)(lseds_1.lseds.div, {
    css: statusIcon
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: textError ? iconError : icon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: textError ? 'exclamation-triangle' : 'info'
  })))), isDropdown && dropdownStatus && data && !!data.length && (0, _core.jsx)(lseds_1.lseds.div, {
    css: optionsContainer,
    onMouseEnter: function onMouseEnter() {
      setVisibleDropdown(true);
    },
    onMouseLeave: function onMouseLeave() {
      setVisibleDropdown(false);
      setDropdownStatus(false);
    }
  }, data.map(function (d, i) {
    return (0, _core.jsx)(lseds_1.lseds.div, {
      key: "option-" + i,
      css: selectedItems.find(function (e) {
        return e.value === d.value;
      }) ? optionRowSelected : optionRow,
      onClick: function onClick(e) {
        updateIndexes(d.value);
      }
    }, (0, _core.jsx)(checkboxes_1.Checkbox, {
      checked: selectedItems.find(function (e) {
        return e.value === d.value;
      }),
      label: d.name,
      noMargin: true
    }));
  })), (textError || helperText) && (0, _core.jsx)(lseds_1.lseds.div, {
    css: message
  }, textError || helperText));
});

if (utils_1.isDev) {
  exports.InputField.displayName = 'InputField';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;